import { useEffect, useRef } from 'react';

/**
 * Poll local library entity data while Phase 2 enrichment is still pending.
 * Stops automatically once `enrichment_attempted_at` is set on the payload.
 */
export function useLocalEnrichmentPoll({
  enabled,
  fetchFn,
  onUpdate,
  intervalMs = 10_000,
}) {
  const onUpdateRef = useRef(onUpdate);
  onUpdateRef.current = onUpdate;

  useEffect(() => {
    if (!enabled || typeof fetchFn !== 'function') return undefined;

    let cancelled = false;
    let timerId = null;

    const poll = async () => {
      try {
        const data = await fetchFn();
        if (cancelled || !data) return;
        onUpdateRef.current?.(data);
        if (data.enrichment_attempted_at) {
          if (timerId) clearInterval(timerId);
          timerId = null;
        }
      } catch {
        /* best-effort polling */
      }
    };

    poll();
    timerId = setInterval(poll, intervalMs);

    return () => {
      cancelled = true;
      if (timerId) clearInterval(timerId);
    };
  }, [enabled, fetchFn, intervalMs]);
}
